import { createBrowserRouter } from "react-router-dom";
import { routes as appRoutes } from "./routesConfig";

export const appRouter = createBrowserRouter(appRoutes);
export { appRoutes as routes, appRouter as router };
